module.exports = __webpack_public_path__ + "media/3_6.4c3853be.wav";